import React, { useState, useRef } from "react";
import axios from "axios";
import { css } from "@emotion/react";
import ClipLoader from "react-spinners/ClipLoader";
import { Trans, useTranslation } from "react-i18next";

const override = css`
    display: block;
    margin: auto;
    border-color: grey;
`;
export default function Form() {
    const ref = useRef("");
    const { t, i18n } = useTranslation();
    const [src, setSrc] = useState("");
    const [infotext, setInfotext] = useState("");
    let [loading, setLoading] = useState(false);

    const [state, setState] = useState({
        value: "",
        show: "",
        spinner: false,
    });

    function input_text_example() {
        const inputSentences = [
            "Ĉiuj redaktantoj de Esperanta Vikipedio estas volontuloj.",
            "Ĉi tiu kategorio enhavas nur la jenan paĝon.",
            "Monda mapo aŭ Mondomapo estas mapo de la tuto de la surfaco de la Tero.",
            "Do, ni simple surmetos ĝin, nun.",
            "Kiu lando estas proksima al Rusio?",
            "Kiuj estas viaj revoj?",
            "Ni havas broŝurojn, gazetojn kaj aliajn",
            "Mi simple volis dividi tion.",
        ];

        const random = Math.floor(Math.random() * inputSentences.length);
        setState({ value: inputSentences[random] });
    }
    const handleChange = (e) => {
        setState({ value: e.target.value });
    };

    const payload = {
        text: state.value,
        speaker: 1,
        format: "wav",
        // format: "mp3",
    };

    function handleClick() {
        if (payload.text.length < 5) {
            setInfotext(t("infotext.server_text_short"));
        } else if (payload.text.length > 100) {
            setInfotext(t("infotext.server_text_long"));
        } else {
            setLoading(true);
            setInfotext(undefined);
            axios({
                // url: "http://localhost:8001/text",
                // url: "http://ttsapi.ddns.net:8001/text",
                url: "https://tts-remote.duckdns.org/text",
                data: payload,
                method: "post",
                responseType: "blob",
            })
                .then((res) => {
                    setSrc(URL.createObjectURL(res.data));
                    setLoading(false);
                    setInfotext(undefined);
                })
                .catch((error) => {
                    setLoading(false);
                    setInfotext(t("infotext.server_down"));
                });
        }
    }

    return (
        <div className="App">
            <h1>{t("page_title")}</h1>
            <form onSubmit={() => handleClick()}>
                <textarea
                    spellcheck="false"
                    value={state.value}
                    ref={ref}
                    onChange={(e) => handleChange(e)}
                    rows="4"
                    cols="50"
                    maxLength="100"
                    placeholder={t("textbox_placeholder")}
                ></textarea>
            </form>

            <button onClick={() => handleClick()}>
                <Trans i18nKey="generate_audio_btn" />
            </button>
            <button onClick={() => input_text_example()}>
                <Trans i18nKey="example_text_btn" />
            </button>
            <div>{infotext}</div>
            <div>
                <ClipLoader loading={loading} css={override} size={50} />
            </div>
            <div>
                <audio id="audio" controls src={src} />
            </div>
        </div>
    );
}
